import React from 'react'
import { Link } from 'react-router-dom'
import { ArrowRight, Home as HomeIcon, Building2, Hotel, Sparkles, Award, Users, CheckCircle2 } from 'lucide-react'

const Home = () => {
  const services = [
    {
      icon: HomeIcon,
      title: 'Residential Design',
      description: 'Transform your home into a personalized sanctuary with our bespoke residential interior design services.'
    },
    {
      icon: Building2,
      title: 'Commercial Spaces',
      description: 'Create inspiring work environments that boost productivity and reflect your brand identity.'
    },
    {
      icon: Hotel,
      title: 'Hospitality Design',
      description: 'Design memorable guest experiences with stunning hospitality interiors that captivate and comfort.'
    }
  ]

  const featuredProjects = [
    {
      image: 'https://images.unsplash.com/photo-1600210492493-0946911123ea?w=800&q=80',
      title: 'Modern Villa',
      category: 'Residential',
      description: 'Contemporary luxury living space'
    },
    {
      image: 'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800&q=80',
      title: 'Executive Office',
      category: 'Commercial',
      description: 'Sophisticated corporate environment'
    },
    {
      image: 'https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?w=800&q=80',
      title: 'Boutique Hotel',
      category: 'Hospitality',
      description: 'Elegant guest experience design'
    }
  ]

  const testimonials = [
    {
      name: 'Priya Sharma',
      role: 'Homeowner',
      text: 'Anu transformed our house into a dream home. Her attention to detail and understanding of our needs was exceptional.',
      rating: 5
    },
    {
      name: 'Rajesh Kumar',
      role: 'Business Owner',
      text: 'The office redesign has completely changed our work culture. Our team loves the new space!',
      rating: 5
    },
    {
      name: 'Meera Patel',
      role: 'Hotel Manager',
      text: 'Our guests constantly compliment the beautiful interiors. Anu\'s design has elevated our brand significantly.',
      rating: 5
    }
  ]

  return (
    <div data-component-path="client/src/pages/Home.jsx" data-component-line="1:1" data-component-id="client/src/pages/Home.jsx:1:1" className="pt-20">
      <section data-component-path="client/src/pages/Home.jsx" data-component-line="2:3" data-component-id="client/src/pages/Home.jsx:2:3" 
               className="relative h-screen flex items-center justify-center bg-cover bg-center"
               style={{ backgroundImage: 'url(https://images.unsplash.com/photo-1618221195710-dd6b41faaea6?w=1920&q=80)' }}>
        <div data-component-path="client/src/pages/Home.jsx" data-component-line="3:5" data-component-id="client/src/pages/Home.jsx:3:5" className="absolute inset-0 bg-black/40"></div>
        <div data-component-path="client/src/pages/Home.jsx" data-component-line="4:5" data-component-id="client/src/pages/Home.jsx:4:5" className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 data-component-path="client/src/pages/Home.jsx" data-component-line="5:7" data-component-id="client/src/pages/Home.jsx:5:7" className="hero-title text-5xl md:text-7xl font-bold text-white mb-6 animate-fade-in">
            Designing Spaces,<br data-component-path="client/src/pages/Home.jsx" data-component-line="6:9" data-component-id="client/src/pages/Home.jsx:6:9" />Creating Experiences
          </h1>
          <p data-component-path="client/src/pages/Home.jsx" data-component-line="7:7" data-component-id="client/src/pages/Home.jsx:7:7" className="text-xl md:text-2xl text-white/90 mb-8 max-w-3xl mx-auto animate-slide-up">
            Transform your vision into reality with award-winning interior design that combines elegance, functionality, and your unique personality.
          </p>
          <div data-component-path="client/src/pages/Home.jsx" data-component-line="8:7" data-component-id="client/src/pages/Home.jsx:8:7" className="flex flex-col sm:flex-row gap-4 justify-center animate-slide-up">
            <Link data-component-path="client/src/pages/Home.jsx" data-component-line="9:9" data-component-id="client/src/pages/Home.jsx:9:9"
              to="/portfolio"
              className="h-14 px-8 bg-amber-600 text-white rounded-lg hover:bg-amber-700 flex items-center justify-center gap-2 focus:ring-4 focus:ring-amber-300/50 transition-all duration-200 shadow-md hover:shadow-lg text-lg font-semibold"
            >
              View Portfolio
              <ArrowRight data-component-path="client/src/pages/Home.jsx" data-component-line="10:11" data-component-id="client/src/pages/Home.jsx:10:11" className="w-5 h-5 flex-shrink-0" />
            </Link>
            <Link data-component-path="client/src/pages/Home.jsx" data-component-line="11:9" data-component-id="client/src/pages/Home.jsx:11:9"
              to="/contact"
              className="h-14 px-8 bg-white text-gray-900 rounded-lg hover:bg-gray-100 flex items-center justify-center gap-2 focus:ring-4 focus:ring-white/50 transition-all duration-200 shadow-md hover:shadow-lg text-lg font-semibold"
            >
              Start Your Project
            </Link>
          </div>
        </div>
      </section>

      <section data-component-path="client/src/pages/Home.jsx" data-component-line="12:3" data-component-id="client/src/pages/Home.jsx:12:3" className="py-20 bg-white">
        <div data-component-path="client/src/pages/Home.jsx" data-component-line="13:5" data-component-id="client/src/pages/Home.jsx:13:5" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div data-component-path="client/src/pages/Home.jsx" data-component-line="14:7" data-component-id="client/src/pages/Home.jsx:14:7" className="text-center mb-16">
            <h2 data-component-path="client/src/pages/Home.jsx" data-component-line="15:9" data-component-id="client/src/pages/Home.jsx:15:9" className="text-4xl md:text-5xl font-bold text-gray-900 mb-4 hero-title">Our Services</h2>
            <p data-component-path="client/src/pages/Home.jsx" data-component-line="16:9" data-component-id="client/src/pages/Home.jsx:16:9" className="text-lg text-gray-600 max-w-2xl mx-auto">
              Comprehensive interior design solutions tailored to your unique needs and vision
            </p>
          </div>

          <div data-component-path="client/src/pages/Home.jsx" data-component-line="17:7" data-component-id="client/src/pages/Home.jsx:17:7" className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {services.map((service, index) => (
              <div data-component-path="client/src/pages/Home.jsx" data-component-line="18:9" data-component-id="client/src/pages/Home.jsx:18:9"
                key={index}
                className="bg-stone-50 p-8 rounded-2xl hover:shadow-xl transition-all duration-300 group"
              >
                <div data-component-path="client/src/pages/Home.jsx" data-component-line="19:11" data-component-id="client/src/pages/Home.jsx:19:11" className="w-16 h-16 bg-amber-100 rounded-xl flex items-center justify-center mb-6 group-hover:bg-amber-600 transition-colors duration-300">
                  <service.icon data-component-path="client/src/pages/Home.jsx" data-component-line="20:13" data-component-id="client/src/pages/Home.jsx:20:13" className="w-8 h-8 text-amber-600 group-hover:text-white flex-shrink-0" />
                </div>
                <h3 data-component-path="client/src/pages/Home.jsx" data-component-line="21:11" data-component-id="client/src/pages/Home.jsx:21:11" className="text-2xl font-bold text-gray-900 mb-4 hero-title">{service.title}</h3>
                <p data-component-path="client/src/pages/Home.jsx" data-component-line="22:11" data-component-id="client/src/pages/Home.jsx:22:11" className="text-gray-600 leading-relaxed">{service.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section data-component-path="client/src/pages/Home.jsx" data-component-line="23:3" data-component-id="client/src/pages/Home.jsx:23:3" className="py-20 bg-stone-50">
        <div data-component-path="client/src/pages/Home.jsx" data-component-line="24:5" data-component-id="client/src/pages/Home.jsx:24:5" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div data-component-path="client/src/pages/Home.jsx" data-component-line="25:7" data-component-id="client/src/pages/Home.jsx:25:7" className="text-center mb-16">
            <h2 data-component-path="client/src/pages/Home.jsx" data-component-line="26:9" data-component-id="client/src/pages/Home.jsx:26:9" className="text-4xl md:text-5xl font-bold text-gray-900 mb-4 hero-title">Featured Projects</h2>
            <p data-component-path="client/src/pages/Home.jsx" data-component-line="27:9" data-component-id="client/src/pages/Home.jsx:27:9" className="text-lg text-gray-600 max-w-2xl mx-auto">
              Explore our recent work and see how we bring dreams to life
            </p>
          </div>

          <div data-component-path="client/src/pages/Home.jsx" data-component-line="28:7" data-component-id="client/src/pages/Home.jsx:28:7" className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {featuredProjects.map((project, index) => (
              <div data-component-path="client/src/pages/Home.jsx" data-component-line="29:9" data-component-id="client/src/pages/Home.jsx:29:9"
                key={index}
                className="group cursor-pointer"
              >
                <div data-component-path="client/src/pages/Home.jsx" data-component-line="30:11" data-component-id="client/src/pages/Home.jsx:30:11" className="relative h-80 rounded-2xl overflow-hidden mb-4">
                  <img data-component-path="client/src/pages/Home.jsx" data-component-line="31:13" data-component-id="client/src/pages/Home.jsx:31:13"
                    src={project.image}
                    alt={project.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                    loading="lazy"
                    onError={(e) => {
                      e.target.src = 'https://images.unsplash.com/photo-1600210492493-0946911123ea?w=800&q=80'
                    }}
                  />
                  <div data-component-path="client/src/pages/Home.jsx" data-component-line="32:13" data-component-id="client/src/pages/Home.jsx:32:13" className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                  <div data-component-path="client/src/pages/Home.jsx" data-component-line="33:13" data-component-id="client/src/pages/Home.jsx:33:13" className="absolute bottom-4 left-4 right-4 text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <span data-component-path="client/src/pages/Home.jsx" data-component-line="34:15" data-component-id="client/src/pages/Home.jsx:34:15" className="text-sm font-medium text-amber-400">{project.category}</span>
                  </div>
                </div>
                <h3 data-component-path="client/src/pages/Home.jsx" data-component-line="35:11" data-component-id="client/src/pages/Home.jsx:35:11" className="text-xl font-bold text-gray-900 mb-2 hero-title">{project.title}</h3>
                <p data-component-path="client/src/pages/Home.jsx" data-component-line="36:11" data-component-id="client/src/pages/Home.jsx:36:11" className="text-gray-600">{project.description}</p>
              </div>
            ))}
          </div>

          <div data-component-path="client/src/pages/Home.jsx" data-component-line="37:7" data-component-id="client/src/pages/Home.jsx:37:7" className="text-center mt-12">
            <Link data-component-path="client/src/pages/Home.jsx" data-component-line="38:9" data-component-id="client/src/pages/Home.jsx:38:9"
              to="/portfolio"
              className="inline-flex h-11 px-6 bg-amber-600 text-white rounded-lg hover:bg-amber-700 items-center justify-center gap-2 focus:ring-4 focus:ring-amber-300/50 transition-all duration-200 shadow-md hover:shadow-lg"
            >
              View All Projects
              <ArrowRight data-component-path="client/src/pages/Home.jsx" data-component-line="39:11" data-component-id="client/src/pages/Home.jsx:39:11" className="w-5 h-5 flex-shrink-0" />
            </Link>
          </div>
        </div>
      </section>

      <section data-component-path="client/src/pages/Home.jsx" data-component-line="40:3" data-component-id="client/src/pages/Home.jsx:40:3" className="py-20 bg-white">
        <div data-component-path="client/src/pages/Home.jsx" data-component-line="41:5" data-component-id="client/src/pages/Home.jsx:41:5" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div data-component-path="client/src/pages/Home.jsx" data-component-line="42:7" data-component-id="client/src/pages/Home.jsx:42:7" className="text-center mb-16">
            <h2 data-component-path="client/src/pages/Home.jsx" data-component-line="43:9" data-component-id="client/src/pages/Home.jsx:43:9" className="text-4xl md:text-5xl font-bold text-gray-900 mb-4 hero-title">What Clients Say</h2>
            <p data-component-path="client/src/pages/Home.jsx" data-component-line="44:9" data-component-id="client/src/pages/Home.jsx:44:9" className="text-lg text-gray-600 max-w-2xl mx-auto">
              Don't just take our word for it - hear from our satisfied clients
            </p>
          </div>

          <div data-component-path="client/src/pages/Home.jsx" data-component-line="45:7" data-component-id="client/src/pages/Home.jsx:45:7" className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {testimonials.map((testimonial, index) => (
              <div data-component-path="client/src/pages/Home.jsx" data-component-line="46:9" data-component-id="client/src/pages/Home.jsx:46:9"
                key={index}
                className="bg-stone-50 p-8 rounded-2xl"
              >
                <div data-component-path="client/src/pages/Home.jsx" data-component-line="47:11" data-component-id="client/src/pages/Home.jsx:47:11" className="flex items-center gap-1 mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Sparkles data-component-path="client/src/pages/Home.jsx" data-component-line="48:13" data-component-id="client/src/pages/Home.jsx:48:13" key={i} className="w-5 h-5 text-amber-500 fill-amber-500 flex-shrink-0" />
                  ))}
                </div>
                <p data-component-path="client/src/pages/Home.jsx" data-component-line="49:11" data-component-id="client/src/pages/Home.jsx:49:11" className="text-gray-700 mb-6 leading-relaxed italic">"{testimonial.text}"</p>
                <div data-component-path="client/src/pages/Home.jsx" data-component-line="50:11" data-component-id="client/src/pages/Home.jsx:50:11">
                  <p data-component-path="client/src/pages/Home.jsx" data-component-line="51:13" data-component-id="client/src/pages/Home.jsx:51:13" className="font-bold text-gray-900">{testimonial.name}</p>
                  <p data-component-path="client/src/pages/Home.jsx" data-component-line="52:13" data-component-id="client/src/pages/Home.jsx:52:13" className="text-sm text-gray-600">{testimonial.role}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section data-component-path="client/src/pages/Home.jsx" data-component-line="53:3" data-component-id="client/src/pages/Home.jsx:53:3" className="py-20 bg-amber-600">
        <div data-component-path="client/src/pages/Home.jsx" data-component-line="54:5" data-component-id="client/src/pages/Home.jsx:54:5" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 data-component-path="client/src/pages/Home.jsx" data-component-line="55:7" data-component-id="client/src/pages/Home.jsx:55:7" className="text-4xl md:text-5xl font-bold text-white mb-6 hero-title">Ready to Transform Your Space?</h2>
          <p data-component-path="client/src/pages/Home.jsx" data-component-line="56:7" data-component-id="client/src/pages/Home.jsx:56:7" className="text-xl text-white/90 mb-8 max-w-2xl mx-auto">
            Let's discuss your vision and create something extraordinary together
          </p>
          <Link data-component-path="client/src/pages/Home.jsx" data-component-line="57:7" data-component-id="client/src/pages/Home.jsx:57:7"
            to="/contact"
            className="inline-flex h-14 px-8 bg-white text-amber-600 rounded-lg hover:bg-gray-100 items-center justify-center gap-2 focus:ring-4 focus:ring-white/50 transition-all duration-200 shadow-md hover:shadow-lg text-lg font-semibold"
          >
            Get In Touch
            <ArrowRight data-component-path="client/src/pages/Home.jsx" data-component-line="58:9" data-component-id="client/src/pages/Home.jsx:58:9" className="w-5 h-5 flex-shrink-0" />
          </Link>
        </div>
      </section>
    </div>
  )
}

export default Home